var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSendMessageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#E621D3",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m23.105 13.22-6.773 2.25c-4.552 1.522-4.552 4.004 0 5.52l2.01.667.668 2.01c1.515 4.552 4.005 4.552 5.52 0l2.257-6.765c1.005-3.038-.645-4.695-3.682-3.683m.24 4.034-2.85 2.865a.56.56 0 0 1-.398.165.56.56 0 0 1-.397-.165.566.566 0 0 1 0-.795l2.85-2.865a.566.566 0 0 1 .795 0 .566.566 0 0 1 0 .795"
})));
export default SvgSendMessageIcon;